import React, { useEffect, useState } from "react"
import { Flex, Box} from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"

const AltContentsContainer = styled(Box)`
  width: 100%;
  max-width: 360px;
  margin: auto;
  @media (min-width: 480px) {
    max-width: 440px;
  }
  @media (min-width: 768px) {
    max-width: 468px;
  }
  color: #22202F;
`

const ButtonsWrap = styled(Flex)`
  margin-left: auto;
  flex-direction: column;
  button.c-btn {
    width: 100%;
    height: 56px;
    @media (min-width: 768px) {
      height: 56px;
    }
    padding-left: 0;
    padding-right: 0;
  }
  
  .pdp-upsell-atc {
    &.inactive {
      border: 1px solid #C8D2D1 !important;
      &:hover {
        border: 1px solid #C8D2D1 !important;
        cursor: not-allowed !important;
      }
      .textelement {
        color: #C8D2D1 !important;
      }
    }
  }
`
const ButtonsHolder = styled.div`
  position: relative;
  width: 100%;
  background: ${theme.color.beige};
  border-radius: 4px;
  margin: 8px 0;
  padding: 0;
  height: auto;
  z-index: 5;
`
const OptionWrap = styled.div`
  width: 100%;
  height: 104px;
  
  @media (min-width: 768px) {
    height: 131px;
  }
  border: 1px solid #C8D2D1;
  border-radius: 8px;
  background: #fff;

  p, svg {
    display: inline-block;
    text-align: left;

    width: 100%;
  }
  
  .option_image {
    @media (max-width: 767px) {
      max-height: 85px;
    }
  }
  
  .option_flex {
    height: 100%;
  }
  
  .c-description {
    max-width: 234px;
  }
  
  .c-title {
    @media (min-width: 1024px) and  (max-width: 1100px) {
      font-size: 16px !important;
    }
  }
`
const HeaderWrap = styled(Flex)`
  padding: 0 16px;
  height: 56px;
  justify-content: space-around;
  background: #E8FAF7;
  border-radius: 8px;
  p.textelement[class*='body--large'] {
    line-height: 56px;
  }
  @media (min-width: 768px) {
    //height: 52px;
  }
`

const headerText = 'Free gift with subscription.'
const source = "minigift_lp"

const GiftFree = ({ option, upsellData, setUpsellData }) => {
  
  const [quantity, ] = useState(1)
  const added = upsellData?.added ? 1 : 0
  const cls = quantity > 0  ? 'active ' : 'inactive '
  
  useEffect(() => {
    if(added && quantity){
      setUpsellData({
        quantity,
        source,
        added: true,
        ...option
      })
    } else {
      setUpsellData(null)
    }
    return ()=> {
      //clean on component destroy
      setUpsellData(null)
    }
    
  }, [added, quantity,  option, setUpsellData])
  
  const renderOption = (idx, type = 'normal')=>{
    
    return <OptionWrap data-sku={option?.sku} id={`option-${option.id}`} key={`opt${idx}`} className={`${cls} ${type}`} onClick={(e)=>{e.preventDefault()}}>
      <Flex alignItems={`center`} className={`option_flex`}>
        <Box width={['72px','100px','100px','100px']} p={[8,16,12,16]}>
          <img src={option?.img} alt={``} className={`option_image`}/>
        </Box>
        <Flex width={['calc(100% - 72px)', 'calc(100% - 100px)', 'calc(100% - 100px)',  'calc(100% - 100px)']} flexDirection={['column']}>
          <Flex flexDirection={['row']} width={[1]} alignItems={['center']}>
            <Box  width={[.6,.7,.66,]} pr={['14px']}>
              <TextElement element="p" text={option.title} className="body--xlarge-b show-md-up c-title" />
              <TextElement element="p" text={option.title} className="body--large-b hide-md-up c-title" />
            </Box>
            <Box width={[.4,.3,.33,]}>
              <div className="show-md-up">
                <TextElement element="span" aria-label={`was ${option.price} dollars, now discounted`} text={`$${option.price}`} className="body--xlarge line-through text-master-base-alt-alt" />
                <TextElement element="span" text={`FREE`} className="body--xlarge-b pl-2" />
              </div>
              <div className="hide-md-up">
                <TextElement element="span" aria-label={`was ${option.price} dollars, now discounted`} text={`$${option.price}`} className="body--large line-through text-master-base-alt-alt" />
                <TextElement element="span" text={`FREE`} className="body--large-b pl-1" />
              </div>
            </Box>
          </Flex>
          <Flex width={[1]}>
            <TextElement element="p" text={option?.text_description} className="body--small show-md-up c-description text-master-base-alt-alt pt-1" />
            <TextElement element="p" text={option?.text_description} className="body--regular hide-md-up c-description text-master-base-alt-alt pt-1" />
          </Flex>
        </Flex>
      </Flex>
    </OptionWrap>
  }
  
  return (
    <AltContentsContainer pt={[24,24,32]}>
      <HeaderWrap>
        <TextElement element="p" text={headerText} className="body--large-b" />
      </HeaderWrap>
      <ButtonsWrap>
        <ButtonsHolder>
          {renderOption()}
        </ButtonsHolder>
      </ButtonsWrap>
    </AltContentsContainer>
  )
}

export default GiftFree